<!-- UOM Reselection Dialog
  Shown when an existing treatment plan item's selectedUom is no longer in the
  current uom_conversions options (e.g. conversion units were updated after the item
  was recorded). Unlike the base UOM mismatch dialog, this does NOT require item
  deletion — the user just needs to pick a new valid UOM from the updated options. -->
<template lang="pug">
yz-dialog(v-if="showDialog" v-model="showDialog" persistent scrollable width="440")
  yz-card
    yz-dialog-normal-header(title="UOM No Longer Available" @close="onCancel")
    yz-dialog-normal-content
      div.yz-regular-body-sm.text-neutral-700.mt-4 The previously selected unit of measure "{{ previousUom }}" is no longer available in the current conversion options.
      div.yz-regular-body-sm.text-neutral-500.mt-2 Please select a new unit of measure to continue.
      div.mt-4
        div.yz-medium-body-xs.text-neutral-500.mb-1 Unit of measure
        medication-unit-of-measure-dropdown(v-model="newUom" :allowedValues="allowedValues" :fieldMinWidth="200" size="md" placeholder="Select UOM" :deletable="false")
    yz-dialog-normal-actions(save-label="Confirm" cancel-label="Cancel" :disableSave="!newUom" @save="onConfirm" @cancel="onCancel")
</template>

<script>
import MedicationUnitOfMeasureDropdown from '@/components/clinic/inventory/MedicationUnitOfMeasureDropdown.vue'

export default {
  components: { MedicationUnitOfMeasureDropdown },
  props: {
    open: {
      type: Boolean,
    },
    // Available UOM options from the current uom_conversions
    allowedValues: {
      type: Array,
      default: () => []
    },
    // The UOM that was previously selected but is no longer valid
    previousUom: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      newUom: null,
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    onCancel () {
      this.$emit('cancel')
      this.showDialog = false
    },
    onConfirm () {
      // Emit the newly selected UOM back to the parent for assignment
      this.$emit('confirm', this.newUom)
      this.showDialog = false
    }
  },
}
</script>
